import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useAccessControl = () => {
  const { token } = useAuth();
  const [accessInfo, setAccessInfo] = useState(null);

  useEffect(() => {
    if (token) fetchAccessInfo();
  }, [token]);

  const fetchAccessInfo = async () => {
    try {
      const res = await axios.get(`${API_URL}/user/access-info`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAccessInfo(res.data);
    } catch (e) {
      // Si erreur 403 (essai expiré), on le signale
      if (e.response?.status === 403) {
        setAccessInfo({ plan: 'expired', is_trial: true });
      }
    }
  };

  const canAccessTheme = (themeSlug) => {
    if (!accessInfo) return true;
    if (accessInfo.is_admin) return true;
    if (!accessInfo.is_trial) return true;
    if (!accessInfo.allowed_themes) return true;
    return accessInfo.allowed_themes.includes(themeSlug);
  };

  const canAccessChapter = (chapterId) => {
    if (!accessInfo) return true;
    if (accessInfo.is_admin) return true;
    if (!accessInfo.is_trial) return true;
    if (!accessInfo.allowed_chapters) return true;
    return accessInfo.allowed_chapters.includes(chapterId);
  };

  const canAccessTool = (toolSlug) => {
    if (!accessInfo) return true;
    if (accessInfo.is_admin) return true;
    if (!accessInfo.is_trial) return true;
    if (!accessInfo.allowed_tools) return true;
    return accessInfo.allowed_tools.includes(toolSlug);
  };

  const isTrial = accessInfo?.is_trial || false;
  const isExpired = accessInfo?.plan === 'expired';
  const isAccompagnement = accessInfo?.is_accompagnement || false;

  return { accessInfo, isTrial, isExpired, isAccompagnement, canAccessTheme, canAccessChapter, canAccessTool };
};
